import { useCreateOpportunityChatSession } from '@/components/chat-v2/hooks/useChatSession'

import { removeCodeMarkdown } from '@/helpers/string'

import type { OpportunitySearchResult } from '@/hooks/opportunity/types'

import type { OpportunityChatSession } from '@/types/chat-v2'
import type { UUID } from '@/types/Id'

interface UseCreateThreadFromOpportunityArgs {
  orgId: UUID | ''
  opportunity: OpportunitySearchResult
}

export const useCreateThreadFromOpportunity = (
  args: UseCreateThreadFromOpportunityArgs,
) => {
  const {
    mutateAsync: createOpportunityChatSession,
    isPending: isCreatingOpportunityChatSession,
  } = useCreateOpportunityChatSession()

  const handleCreateThread =
    async (): Promise<OpportunityChatSession | null> => {
      if (!args.orgId) {
        return null
      }
      try {
        return await createOpportunityChatSession({
          opportunity_id: args.opportunity.id,
          opportunity_type: args.opportunity.type,
          title: removeCodeMarkdown(args.opportunity.title),
          organization_id: args.orgId,
        })
      } catch (err) {
        console.error(err)
      }
      return null
    }

  return {
    mutateAsync: handleCreateThread,
    isPending: isCreatingOpportunityChatSession,
  }
}
